/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_2025_Q3Inputs */

const en_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Exclusive Trees  | Apricot Tree, Bird of Paradise, Confederate Rose, Royal Poinciana, Rainbow Eucalyptus |  
| --- | --- | 
| Selected Trees | Kitty, Watermelon, Sunflower, Rose, Baobab, Yellow Oak Tree, Strawberry Chiffon Cake, Starburst Tree, Space Tree, Camellia, Osmanthus, Cosmos, Golden Trumpet Tree, Cloud Moon Tree, Wishing Flower |
| Plus-Exclusive Sounds | Energy Drive, Waking Groove, Override Flow |
| Selected Sounds | Times Square, (Lofi) Floating Through Forests, (Lofi) Inspiration Beats, Waterfall (White Noise), Waterfall (Pink Noise), Waterfall (Brown Noise), Binaural Beats 16 Hz |`)
};

const ar_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| اشجار بلس الحصرية |  شجرة المشمش, طائر الجنة, وردة الكونفدرالية, رويال بوانسيانا, زهرة قوس قزح | 
 | --- | --- | 
 | أشجار مختارة | قطة, بطيخ, عباد الشمس, ورد, شجرة الباوباب, شجرة بلوط صفراء, شيفون فراولة كيك, الشجرة النجمية, شجرة الفضاء, كاميليا, أوسمانثوس, كوزموس, شجرة الترومبيت الذهبية, شجرة القمر الضبابي, زهرة الأمنيات | 
 | اصوات بلس الحصرية | محرك الطاقة, إيقاع الاستيقاظ, تجاوز التدفق | 
 | الأصوات المختارة | ميدان التايمز, (لوفي) اطفو عبر الغابات, (لوفي) إيقاعات الإلهام, شلال (ضوضاء بيضاء), شلال (ضوضاء وردية), شلال (ضوضاء بنية), نبضات ثنائية التردد 16 هرتز |`)
};

const de_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Exclusive Trees |  Aprikosenbaum, Paradiesvogel, Konföderierte Rose, Königliche Poinciana, Regenbogen Eukalyptus | 
| --- | --- | 
| Ausgewählte Bäume | Kätzchen, Wassermelone, Sonnenblume, Rose, Baobab, Gelbe Eiche, Erdbeer-Chiffon, Sternenstaub-Baum, Weltraumbaum, Kamelie, Osmanthus, Kosmos, Goldener Trompetenbaum, Wolken-Mond-Baum, Wunschblume | 
| Plus-Exclusive Sounds | Energieantrieb, Waking Groove, Override Flow | 
| Ausgewählte Klänge | Times Square, (Lofi) Schwebend durch die Wälder, (Lofi) Inspiration Beats, Wasserfall (Weißes Rauschen), Wasserfall (Rosa Rauschen), Wasserfall (Braunes Rauschen), Binaurale Beats 16 Hz | `)
};

const es_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Árboles Exclusivos Plus |  Árbol del albaricoque, Ave del paraíso, Rosa de mayo, Flamboyán, Eucalipto arcoíris |  
| --- | --- |
| Árboles Seleccionados | Gatito, Sandía, Girasol, Rosa, Baobab, Roble amarillo, Pastel Chiffon con fresas, Árbol de estallido, Árbol espacial, Camelia, Osmanto, Cosmos, Árbol Trompeta Dorada, Árbol de la Luna Nublada, Flor de los deseos |
| Sonidos Exclusivos Plus | Impulso Energético, El ritmo del despertar, Anular el flujo |
| Sonidos Seleccionados | Times Square, (Lofi) Flotando por los Bosques, (Lofi) Ritmos de Inspiración, Cascada (ruido blanco), Cascada (ruido rosa), Cascada (ruido marrón), Sonidos binaurales de 16 Hz |`)
};

const fr_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Arbres exclusifs Plus | Abricotier, Oiseau de Paradis, Rose Confédérée, Flamboyant Royal, Eucalyptus Arc-en-Ciel |
| --- | --- |
| Arbres sélectionnés | Chaton, Pastèque, Tournesol, Rose Rouge, Baobab, Chêne jaune, Tarte chiffon aux fraises, Arbre d'étoile rayonnante, Arbre de l'Espace, Camélia, Osmanthus, Cosmos, Arbre aux Trompettes d’Or, Lune Céleste, Fleur à souhaits |
| Sons exclusifs Plus | Boost d'Énergie, Réveil en Rythme, Reprise de Contrôle |
| Sons sélectionnés | Times Square, (Lofi) Rêverie Forestière, (Lofi) Rythmes inspirants, Cascade (bruit blanc), Cascade (bruit rose), Cascade (bruit brun), Battements binauraux 16 Hz |`)
};

const it_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Più alberi esclusivi |  Albero di Albicocche, Uccello del Paradiso, Rosa Confederata, Flamboyant, Eucalipto Arcobaleno |  
| --- | --- | 
| Alberi selezionati | Gattino, Anguria, Girasole, Rosa Rossa, Baobab, Quercia Gialla, Strawberry Chiffon Cake, Albero Supernova, Albero Spaziale, Camelia, Osmanto, Cosmea, Albero Tromba Dorata, Albero Nuvola Lunare, Fiore dei Desideri |
| Più suoni esclusivi | Azionamento dell'Energia, Ritmo di Risveglio, Sovrascrivi Flusso |
| Suoni selezionati | Times Square, (Lofi) Fluttuando tra le foreste, (Lofi) Beat di ispirazione, Cascata (rumore bianco), Cascata (rumore rosa), Cascata (rumore marrone), Binaural Beats 16 Hz |`)
};

const ja_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus限定の木 | アプリコットの木、ゴクラクチョウカ、フヨウ、ホウオウボク、レインボーユーカリ | 
 | --- | --- | 
 | 厳選された木 | にゃんこ、スイカ、ヒマワリ、バラ、バオバブ、黄色いナラの木、イチゴシフォンケーキ、スターバーストの木、宇宙に浮かぶ木、ツバキ、キンモクセイ、コスモス、コガネノウゼン、雲月の木、願いの花 | 
 | Plus限定サウンド | エナジードライブ、目覚めの律動、覚醒への導き | 
 | 厳選サウンド | タイムズスクエア、(Lo-Fi) 森の中を漂う、(Lo-Fi)  ひらめきのビート、滝（ホワイトノイズ）、滝（ピンクノイズ）、滝（ブラウンノイズ）、バイノーラルビート 16Hz |`)
};

const ko_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 전용 나무 |  살구나무, 극락조화, 컨페더러트 로즈, 봉황목, 무지개 유칼립투스 | 
| --- | --- | 
| 선택된 나무 | 고양이 나무, 수박, 해바라기, 장미, 바오밥 나무, 노란색 참나무, 딸기 쉬폰 케이크, 소행성 나무, 스페이스 나무, 동백나무, 오스만투스, 코스모스, 노란 트럼펫 트리, 구름 달 나무, 소원꽃 |
| Plus 전용 사운드 | 에너지 드라이브, 웨이킹 그루브, 오버라이드 플로우 |
| 선택된 사운드 | 타임스퀘어, (로파이) 숲속을 떠다니며, (로파이) 영감을 주는 비트, 폭포(화이트 노이즈), 폭포(핑크 노이즈), 폭포(브라운 노이즈), 바이노럴 비트 16Hz |`)
};

const pt_br_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Árvores exclusivas Plus  |  Damasqueiro, Ave-do-paraíso, Rosa-louca, Acácia-rubra, Eucalipto arco-íris |  
| --- | --- | 
| Árvores selecionadas | Bichano, Melancia, Girassol, Rosa, Baobá, Carvalho Amarelo, Bolo chiffon de morango, Chuva de estrelas, Árvore espacial, Camélia, Flor do Imperador, Cosmos, Ipê Amarelo, Árvore Lua Nebulosa, Flor dos Desejos |
| Sons exclusivos Plus | Impulso de Energia, Ritmo do Despertar, Substituir fluxo |
| Sons selecionados | Times Square, (Lo-Fi) Pairando pelas florestas, (Lo-Fi) Batidas de inspiração, Cachoeira (ruído branco), Cachoeira (ruído rosa), Cachoeira (ruído marrom), Batidas binaurais 16 Hz |`)
};

const ru_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Эксклюзивные растения Plus |  Абрикос, Стрелиция королевская, Гибискус изменчивый, Огненное дерево, Эвкалипт радужный | 
| --- | --- | 
| Избранные растения | Котёнок, Арбуз, Подсолнечник, Роза, Баобаб, Жёлтый дуб, Клубничный торт, Дерево Звездообразования, Космическое Дерево, Камелия, Османтус, Космея, Золотая табебуйя, Облачное лунное дерево, Цветок желания |
| Эксклюзивные звуки Plus | Энергетический драйв, Пробуждающий ритм, Перенаправление потока |
| Избранные звуки | Таймс-сквер, (Lo-Fi) Перемещение сквозь леса, (Lo-Fi) Вдохновляющие биты, Водопад (белый шум), Водопад (розовый шум), Водопад (коричневый шум), Бинауральные ритмы: 16 Гц |`)
};

const th_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| ต้นไม้สุดพิเศษเฉพาะ Plus  | ต้นแอปริคอท、ปักษาสวรรค์、พุดตาน、หางนกยูงฝรั่ง、ยูคาลิปตัสสีรุ้ง |  
| --- | --- | 
| ต้นไม้ที่ถูกคัดสรร | ต้นทาสแมว、แตงโม、ดอกทานตะวัน、กุหลาบ、เบาบับ、ต้นโอ๊กสีเหลือง、เค้กชิฟฟ่อนสตรอเบอร์รี่、ต้นดาวกระจาย、ต้นอวกาศ、คามีเลีย、ดอกหอมหมื่นลี้、คอสมอส、ต้นเหลืองอินเดีย、ต้นพระจันทร์ดั้นเมฆ、ดอกความปรารถนา |
| เสียงสุดพิเศษเฉพาะ Plus | พลังขับเคลื่อน、บีตปลุกพลัง、ปลุกโฟลว์ใหม่ |
| เสียงที่ถูกคัดสรร | ไทม์สแควร์、(Lofi) โบยบินผ่านผืนป่า、(Lofi) บีทแห่งแรงบันดาลใจ、น้ำตก (เสียงสีขาว)、น้ำตก (เสียงสีชมพู)、น้ำตก (เสียงสีน้ำตาล)、เสียงบีทสองข้าง 16 เฮิรตซ์ |`)
};

const tr_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Özel Ağaçlar |  Kayısı Ağacı, Cennet Kuşu, Konfederasyon Gülü, Kraliyet Poincianası, Gökkuşağı Okaliptüsü | 
| --- | --- | 
| Seçilen Ağaçlar | Kedicik, Karpuz, Ayçiçeği, Gül, Maymun Ekmeği Ağacı, Sarı Meşe Ağacı, Çilekli Şifon Pasta, Yıldız Yağmuru Ağacı, Uzay Ağacı, Kamelya, Osmanthus, Evren, Altın Trompet Ağacı, Bulut Ayı Ağacı, Dilek Çiçeği |
| Plus Özel Sesleri | Enerji Sürüşü, Uyanma Oluğu, Akışı Geçersiz Kıl |
| Seçilen Sesler | Times Meydanı, (Lofi) Ormanların Arasında Süzülmek, (Lofi) İlham Vuruşları, Şelale (Beyaz Gürültü), Şelale (Pembe Gürültü), Şelale (Kahverengi Gürültü), Stereofonik Sesler 16 Hz |`)
};

const zh_cn_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 独享树种  |  杏花、天堂鸟、木芙蓉、凤凰木、彩虹桉 |  
| --- | --- | 
| 特选树种 | 猫咪、西瓜、向日葵、玫瑰、猴面包树、黄色橡树、草莓戚风蛋糕、烟花树、太空树、山茶花、桂花、波斯菊、黄金风铃木、云月树、祈愿花 |
| Plus 独享声音 | 专注动能、清醒律动、超速心流 |
| 特选声音 | 纽约时代广场、(Lofi) 漂浮在森林、(Lofi) 灵感节奏、瀑布（白噪音）、瀑布（粉红噪音）、瀑布（棕噪音）、双耳节拍 16 赫兹 |`)
};

const zh_tw_content_2025_q3 = /** @type {(inputs: Content_2025_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 獨享樹種  | 杏花、天堂鳥、木芙蓉、鳳凰木、彩虹桉 |  
| --- | --- | 
| 精選樹種 | 貓咪、西瓜、向日葵、玫瑰、猴麵包樹、黃色橡樹、草莓戚風蛋糕、煙火樹、太空樹、山茶花、桂花、波斯菊、黃金風鈴木、雲月樹、祈願花 |
| Plus 獨享聲音 | 專注動能、清醒律動、超速心流 |
| 精選聲音 | 紐約時代廣場、(Lofi) 漂浮在森林、(Lofi) 靈感節奏、瀑布（白噪音）、瀑布（粉紅噪音）、瀑布（棕噪音）、雙耳節拍 16 赫茲 |`)
};

/**
* | output |
* | --- |
* | "\| Plus-Exclusive Trees \| Apricot Tree, Bird of Paradise, Confederate Rose, Royal Poinciana, Rainbow Eucalyptus \| \| --- \| --- \| \| Selected Trees \| Kitty, Wate..." |
*
* @param {Content_2025_Q3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const content_2025_q3 = /** @type {((inputs?: Content_2025_Q3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_2025_Q3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_content_2025_q3(inputs)
	if (locale === "ar") return ar_content_2025_q3(inputs)
	if (locale === "de") return de_content_2025_q3(inputs)
	if (locale === "es") return es_content_2025_q3(inputs)
	if (locale === "fr") return fr_content_2025_q3(inputs)
	if (locale === "it") return it_content_2025_q3(inputs)
	if (locale === "ja") return ja_content_2025_q3(inputs)
	if (locale === "ko") return ko_content_2025_q3(inputs)
	if (locale === "pt_br") return pt_br_content_2025_q3(inputs)
	if (locale === "ru") return ru_content_2025_q3(inputs)
	if (locale === "th") return th_content_2025_q3(inputs)
	if (locale === "tr") return tr_content_2025_q3(inputs)
	if (locale === "zh_cn") return zh_cn_content_2025_q3(inputs)
	return zh_tw_content_2025_q3(inputs)
});